import _ from "lodash";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { momentLocalizer } from "react-big-calendar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addHourAndSetTime, SessionKeys } from "../../../utils/AppUtils";
import { getSlots } from "../../../redux/user/actions";
import "./AddSchedule.scss";
import { addSlots, addSlotsClear, createSlots, createSlotsClear, deleteSlotsClear } from "../../../redux/coaching/actions";
import { RRule } from "rrule";
import Loader from "../../../components/Loader/Loader";

const AddScheduleComp = (props) => {

  const { showAdd, setShowAdd, formData, setFormData, formResetObj, getslots,from,itemId,hour,request_type,isCoach } = props;

   const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  const maxTime = `${yyyy}-${mm}-${dd}T20:00`;


  const [ruleString, setRuleString] = useState("");
  const [occurrences, setOccurrences] = useState([]);
  const [frequency, setFrequency] = useState("daily"); // Daily, Weekly, or Monthly
  const [dailyOption, setDailyOption] = useState("everyday"); // everyday or everyweekday
  const [nestedMonthly, setNestedMonthly] = useState("");
  const [scheduleType, setScheduleType] = useState(from ==="4hour"?"single":"recurring");
  const [rangeOfOccurence, setRangeOfOccurence] = useState("");
  const [toText, setToText] = useState("");
  const [slotsData, setSlotsData] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const localizer = momentLocalizer(moment);

  const createSlotsData = useSelector((state) => state.coaching.createSlotsData);
  const addSlotsData = useSelector((state) => state.coaching.addSlotsData);
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const [userDetails, setUserDetails] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  // const [timeZone, setTimeZone] = useState();
  // const [timezoneList, setTimezoneList] = useState([]);

  const [errors, setErrors] = useState({});

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputRefs = {
    startDate: useRef(null),
    startTime: useRef(null),
    endDate: useRef(null),
    endTime: useRef(null),
    url: useRef(null),
    // timeZone: useRef(null),
    weeklyDays: useRef(null),
    dayOfMonth: useRef(null),
    firstSecondThird: useRef(null),
    dayWeekdayWeekend: useRef(null),
    monthNo: useRef(null),
  };

  const authBroker = useSelector((state) => state.auth.authBroker);
  const slotsList = useSelector((state) => state.user);
  // const userRole = useSelector((state) => state.user.role);
  const groupWorkshopStore = useSelector((state) => state.groupworkshop);

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    // console.log('userDetailRes: ', userDetailRes)
    if (!_.isEmpty(userDetailRes?.payload?.payload)) {
      setUserDetails(userDetailRes?.payload?.payload);
    }
  }, [userDetailRes]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    console.log("xcxc", formData.startDate)
    console.log("xcxc1", formData.endDate)

    // if(formData.startDate > formData.endDate){      
    //   formData.endDate = ""
    // }

    if (name === "dayOfMonth") {
      const dayValue = Number(value);

      if (dayValue >= 1 && dayValue <= 31) {
        // Valid day, update form data and clear the error
        setFormData((prevData) => ({ ...prevData, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
      } else {
        // Invalid day, reset form data and show an error
        setFormData((prevData) => ({ ...prevData, [name]: "" }));
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Please enter a valid day (1-31).",
        }));
      }
      return;
    }

    if (name === "startTime") {

      let formDataTemp = _.cloneDeep(formData);
      console.log("startDateeee", e);
      let tempstartTime = _.cloneDeep(value);
      if(tempstartTime?.split(":")[0]==="23"){
        tempstartTime = "23:00"
      }
      if(hour === 4 && Number(tempstartTime?.split(":")[0])>="20"){
        tempstartTime = "20:00"
      }
      if(hour === 8 && Number(tempstartTime?.split(":")[0])>="16"){
        tempstartTime = "16:00"
      }

      formDataTemp.startTime = tempstartTime;
      formDataTemp.endTime = addHourAndSetTime(tempstartTime,from === "4hour"?hour:1);
      setFormData(formDataTemp);

    } else if (name === "startDate") {
      let formDataTemp = _.cloneDeep(formData);
      console.log("startDateeee", e);
      formDataTemp.startDate = value;
      formDataTemp.endDate = value;
      setFormData(formDataTemp);
    } else {
      setFormData((prevData) => {
        if (type === "checkbox") {
          // Handle checkbox logic for multiple selections
          const updatedDays = checked
            ? [...(prevData[name] || []), value] // Add the selected value
            : (prevData[name] || []).filter((day) => day !== value); // Remove the deselected value
          return { ...prevData, [name]: updatedDays };
        }
        return { ...prevData, [name]: value }; // Handle other input types
      });
    }




    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  useEffect(() => {
    if(from !== "4hour"){
    getslots();
    }
  }, [dispatch]);


  

  const newErrors = {};
  const handleSubmit = (e) => {
    e.preventDefault();
    setSuccessMsg("")
    setErrorMsg("")

    if (!formData.startDate) {
      newErrors.startDate = "Start Date is required";
    }

    if (!formData.startTime) {
      newErrors.startTime = "Start Time is required";
    }

    if (!formData.endDate) {
      newErrors.endDate = "End Date is required";
    }

    if (!formData.endTime) {
      newErrors.endTime = "End Time is required";
    }
    if (!formData.url) {
      newErrors.url = "URL is required";
    }
    // if (!formData.timeZone) {
    //   newErrors.timeZone = "Timezone is required";
    // }
    if (
      frequency === "weekly" &&
      (!formData.weeklyDays || formData.weeklyDays.length === 0)
    ) {
      newErrors.weeklyDays = "Please select at least one day.";
    }

    if (frequency === "monthly" && nestedMonthly === "1" && !formData.dayOfMonth) {
      newErrors.dayOfMonth = "Day of month is required";
    }
    if (frequency === "monthly" && nestedMonthly === "2" && !formData.firstSecondThird) {
      newErrors.firstSecondThird = "Please select a value.";
    }
    if (frequency === "monthly" && nestedMonthly === "2" && !formData.dayWeekdayWeekend) {
      newErrors.dayWeekdayWeekend = "Please select a value.";
    }
    if (frequency === "monthly" && nestedMonthly === "2" && !formData.monthNo) {
      newErrors.monthNo = "Please select a month number.";
    }
    // if (Object.keys(newErrors).length > 0) {
    //   setErrors(newErrors);
    //   // Focus on the first invalid field
    //   const firstErrorField = Object.keys(newErrors)[0];
    //   inputRefs[firstErrorField].current.focus();
    //   return;
    // }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);

      // Focus on the first invalid field
      const firstErrorField = Object.keys(newErrors)[0];

      // Check if the reference exists before attempting to focus
      if (inputRefs[firstErrorField] && inputRefs[firstErrorField].current) {
        inputRefs[firstErrorField].current.focus();
      }
      return;
    }


    // Combine date and time into JavaScript Date objects
    // const startDateTime = new Date(
    //   `${formData.startDate}T${formData.startTime}`
    // );
    const startDateTime = new Date(
      `${formData.startDate}T${formData.startTime}Z`
    );

    const endDateTime = new Date(`${formData.endDate}T${formData.endTime}Z`);

    console.log("startDateTime:", startDateTime);
    console.log("endDateTime:", endDateTime);

    // Create RRule
    const rruleOptions = {
      dtstart: startDateTime,
      until: endDateTime ? endDateTime : "",
    };

    switch (frequency) {
      case "daily":
        rruleOptions.freq = RRule.DAILY;
        if (dailyOption === "everyweekday") {
          rruleOptions.byweekday = [
            RRule.MO,
            RRule.TU,
            RRule.WE,
            RRule.TH,
            RRule.FR,
          ]; // Weekdays (Mon-Fri)
        }
        if (rangeOfOccurence) {
          console.log("rangeofocc", rangeOfOccurence);
          rruleOptions.count = rangeOfOccurence;
        }
        break;

      case "weekly":
        rruleOptions.freq = RRule.WEEKLY;
        if (formData.weeklyDays.length > 0) {
          // Convert selected days into RRule values (Mon-Sun)
          rruleOptions.byweekday = formData.weeklyDays.map((day) => {
            switch (day) {
              case "mon":
                return RRule.MO;
              case "tue":
                return RRule.TU;
              case "wed":
                return RRule.WE;
              case "thu":
                return RRule.TH;
              case "fri":
                return RRule.FR;
              case "sat":
                return RRule.SA;
              case "sun":
                return RRule.SU;
              default:
                return null;
            }
          });
        }

        if (rangeOfOccurence) {
          console.log("rangeofocc", rangeOfOccurence);
          rruleOptions.count = rangeOfOccurence;
        }
        break;

      case "monthly":
        console.log("In Monthly Case");
        rruleOptions.freq = RRule.MONTHLY;

        if (nestedMonthly === "1") {
          // Day of the Month rule (e.g., 15th of every month)
          rruleOptions.bymonthday = [parseInt(formData.dayOfMonth, 10)];
        } else if (nestedMonthly === "2") {
          const validOccurrences = {
            first: 1,
            second: 2,
            third: 3,
            fourth: 4,
            last: 5, // Use -1 for the last occurrence
          };

          const dayOfWeekMap = {
            sunday: RRule.SU,
            monday: RRule.MO,
            tuesday: RRule.TU,
            wednesday: RRule.WE,
            thursday: RRule.TH,
            friday: RRule.FR,
            saturday: RRule.SA,
          };

          // Check if valid values are selected
          if (formData.firstSecondThird && formData.dayWeekdayWeekend) {
            console.log(
              "First/Second/Third Occurrence:",
              formData.firstSecondThird
            );
            console.log("Day of Week:", formData.dayWeekdayWeekend);

            const occurrence =
              validOccurrences[formData.firstSecondThird.toLowerCase()];
            const dayOfWeek =
              dayOfWeekMap[formData.dayWeekdayWeekend.toLowerCase()];
            console.log(
              "dayOfWeekMap",
              dayOfWeekMap[formData.dayWeekdayWeekend.toLowerCase()]
            );

            if (occurrence) {
              rruleOptions.bysetpos = occurrence;
            }
            if (dayOfWeek) {
              rruleOptions.byweekday = dayOfWeek;
            }

            // If a specific month is selected, add it as part of the rule
            if (formData.monthNo) {
              rruleOptions.interval = parseInt(formData.monthNo, 10); // Month number (1-12)
            }
          }
        }
        if (rangeOfOccurence) {
          console.log("rangeofocc", rangeOfOccurence);
          rruleOptions.count = rangeOfOccurence;
        }

        break;
    }

    // if (formData.timeZone) {
    //   rruleOptions.tzid = formData.timeZone;
    // }

    // Assuming rule.toString() returns the rrule string
    const rule = new RRule(rruleOptions); // Example: "DTSTART:20241231T101800Z\nRRULE:UNTIL=20241231T111900Z"

    console.log("Generated RRule:", rule);

    const toText = rule.toText();
    setToText(toText);
    console.log(toText);

    // Append the URL to the rrule string
    const updatedRuleString = `${rule}`;
    console.log("updatedRuleString", updatedRuleString);

    const dtstartMatch = updatedRuleString.match(/DTSTART:(\d{8}T\d{6}Z)/);
    let dtstartt;
    if (dtstartMatch) {
      dtstartt = dtstartMatch[1];
      console.log("DTSTART:", dtstartt); // Output: 20240315T153000Z
    }

    const updatedRuleCleaned = updatedRuleString
      .replace(/DTSTART:.*\n?/, "") // Remove the DTSTART line
      .replace(/RRULE:\s*/, "");

    // Call setRuleString with the updated rule string

    setRuleString(updatedRuleString);

    setOccurrences(rule.all());
    console.log("occx", rule.all());

    if (localStorage.getItem(SessionKeys.API_TOKEN_BROKER)) {
      console.log("hi");
      setIsLoading(true);

      let reqObj = {
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER) || "",
        dtstart: dtstartt, //"20250108T180000Z",
        slot_payload: updatedRuleCleaned ? updatedRuleCleaned : "",
        start_time: formData.startTime,
        end_time: formData.endTime,
        url: formData.url,
      }
      if(from === "4hour"){
        reqObj.id = itemId;
        reqObj.request_type = request_type;
        reqObj.hour = hour;
      }
      if(isCoach){
        reqObj.is_coach = isCoach
      }


      if(from === "4hour"){
        dispatch(
          addSlots({
            module: "addSlot",
            postData: reqObj,
          })
        );
      }else{ 
        dispatch(
          createSlots({
            module: "createSlot",
            postData: reqObj,
          })
        );
      }
      
    }
  };

  useEffect(() => {
    console.log("createSlotsData", createSlotsData);
    if (!_.isEmpty(createSlotsData)) {
      setIsLoading(false);
      if (createSlotsData?.status === "success") {
        if (successMsg === "") {
          setSuccessMsg("Your available slots added successfully");
        }
        setTimeout(() => {
          setSuccessMsg("");
        }, 5000);
        getslots();
        setFormData(formResetObj);
        dispatch(createSlotsClear());
      } else {
        console.error("Failed to fetch slots.");

      }
    }
  }, [createSlotsData]);

  useEffect(() => {
    console.log("addSlotsData", addSlotsData);
    if (!_.isEmpty(addSlotsData)) {
      setIsLoading(false);
      if (addSlotsData?.status === "success") {
        if (successMsg === "") {
          setSuccessMsg("Your available slots added successfully");
        }
        setTimeout(() => {
          setSuccessMsg("");
          setShowAdd(false);
        }, 3000);
        getslots();
        setFormData(formResetObj);
        dispatch(addSlotsClear());
      } else {
        setErrorMsg(addSlotsData?.error?.message);
        setTimeout(() => {
          setErrorMsg("");
        }, 3000);
        dispatch(addSlotsClear());
        console.error("Slots not av");

      }
    }
  }, [addSlotsData]);





  const handleFrequencyChange = (e) => {
    setFrequency(e.target.value);
    if (e.target.value === "daily" || e.target.value === "monthly") {
      console.log("inside of it");
      setErrors((prevErrors) => ({ ...prevErrors, weeklyDays: "" }));
    }
    if (e.target.value === "monthly") {
      newErrors.weeklyDays = "";
      setNestedMonthly("1");
    }
    if (e.target.value === "daily") {
      newErrors.weeklyDays = "";
      setDailyOption("everyday");
    }
    if (e.target.value === "weekly") {
      setErrors((prevErrors) => ({ ...prevErrors, dayOfMonth: "" }));
      setErrors((prevErrors) => ({ ...prevErrors, firstSecondThird: "" }));
      setErrors((prevErrors) => ({ ...prevErrors, dayWeekdayWeekend: "" }));
      setErrors((prevErrors) => ({ ...prevErrors, monthNo: "" }));
      // newErrors.dayOfMonth = "";
      //   newErrors.firstSecondThird = "";
      //   newErrors.dayWeekdayWeekend = "";
      //   newErrors.monthNo = "";
    }
  };

  const handleNestedMonthlyChange = (e) => {
    const { name, value } = e.target;
    setNestedMonthly(value);
    if (name === "nestedMonthly" && value === "2") {
      setErrors((prevErrors) => ({ ...prevErrors, dayOfMonth: "" }));
    }

    if (name === "nestedMonthly" && value === "1") {
      setErrors((prevErrors) => ({ ...prevErrors, firstSecondThird: "" }));
      setErrors((prevErrors) => ({ ...prevErrors, dayWeekdayWeekend: "" }));
      setErrors((prevErrors) => ({ ...prevErrors, monthNo: "" }));
    }

    if (value === "1") {
      setFormData((prevData) => ({ ...prevData, firstSecondThird: "" }));
      setFormData((prevData) => ({ ...prevData, dayWeekdayWeekend: "" }));
      setFormData((prevData) => ({ ...prevData, monthNo: "" }));
    }
    if (value === "2") {
      setFormData((prevData) => ({ ...prevData, dayOfMonth: "" }));
    }
  };

  const handleRangeOfOccurence = (e) => {
    const occValue = e.target.value;
    if (occValue >= 1 && occValue <= 20) {
      setRangeOfOccurence(occValue);
    } else {
      setRangeOfOccurence("");
    }
  };

  



  return (
    <>

      {showAdd && <div className={from === "4hour"?"entry-animation":"col-lg-4 entry-animation"}>
        <Loader start={isLoading} />
        <div
          className="right-fromd"

        >
          <h4 className="titex mb-3">Select Schedule</h4>
          {from !== "4hour" && <div className="row mb-3">
            <div className="col-md-6 pe-0">
              <div className="form-check ">
                <input
                  className="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                  value="single"
                  checked={scheduleType === "single"}
                  onChange={(e) => {
                    setScheduleType(e.target.value);
                    setFrequency("daily");
                    setDailyOption("");

                    let formDataTemp = _.cloneDeep(formData);
                    formDataTemp.endDate = formDataTemp.startDate;
                    setFormData(formDataTemp);
                  }}
                />
                <label
                  className="form-check-label"
                  htmlFor="flexRadioDefault1"
                >
                  Single Schedule
                </label>
              </div>
            </div>
            <div className="col-md-6 ps-0">
              <div className="form-check ">
                <input
                  className="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault2"
                  value="recurring"
                  checked={scheduleType === "recurring"}
                  onChange={(e) => setScheduleType(e.target.value)}
                />
                <label
                  className="form-check-label"
                  htmlFor="flexRadioDefault2"
                >
                  Recurring Schedule
                </label>
              </div>
            </div>
          </div>}
          <div>
            <form onSubmit={handleSubmit} noValidate>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">Start Date</label>
                  <input
                    type="date"
                    name="startDate"
                    value={formData.startDate}
                    className="form-control"
                    onChange={handleChange}
                    ref={inputRefs.startDate}
                    min={new Date().toISOString().split('T')[0]}
                    required
                  />
                  {errors.startDate && (
                    <span style={{ color: "red" }}>
                      {errors.startDate}
                    </span>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">End Date</label>
                  <input
                    type="date"
                    name="endDate"
                    value={formData.endDate}
                    className="form-control"
                    onChange={handleChange}
                    ref={inputRefs.endDate}
                    min={formData.startDate ? formData.startDate : ""}
                    disabled={!formData.startDate || scheduleType === "single"}
                    required={!rangeOfOccurence}
                  />
                  {errors.endDate && (
                    <span style={{ color: "red" }}>
                      {errors.endDate}
                    </span>
                  )}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">Start Time</label>
                  <input
                    type="time"
                    name="startTime"
                    value={formData.startTime}
                    className="form-control"
                    onChange={handleChange}
                    ref={inputRefs.startTime}
                    required
                  />
                  {errors.startTime && (
                    <span style={{ color: "red" }}>
                      {errors.startTime}
                    </span>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">End Time</label>
                  <input
                    type="time"
                    name="endTime"
                    value={formData.endTime}
                    className="form-control"
                    onChange={handleChange}
                    ref={inputRefs.endTime}
                    disabled={true}
                    required
                  />
                  {errors.endTime && (
                    <span style={{ color: "red" }}>
                      {errors.endTime}
                    </span>
                  )}
                </div>
              </div>
              { <div className="row mb-3">
                <div className="col-md-12">
                  <label className="form-label">URL</label>
                  <input
                    type="text"
                    name="url"
                    value={formData.url}
                    className="form-control"
                    onChange={handleChange}
                    ref={inputRefs.url}
                    required
                  />
                  {errors.url && (
                    <span style={{ color: "red" }}>{errors.url}</span>
                  )}
                </div>
                {/* <div className="col-md-12">
                        <label className="form-label">Timezone</label>
                        <select
                          value={formData.timeZone}
                          name="timeZone"
                          onChange={handleChange}
                          ref={inputRefs.timeZone}
                          className="form-select"
                          required
                        >
                          <option value="">Select</option>
                          {timezoneList.map((tz) => (
                            <option key={tz.id} value={tz.abbreviations}>
                              {`${tz.timezone} (${tz.offset})`}
                            </option>
                          ))}
                        </select>
                        {errors.timeZone && (
                          <span style={{ color: "red" }}>
                            {errors.timeZone}
                          </span>
                        )}
                        </div> */}
              </div>}
              {/* recurrence fields */}
              {scheduleType === "recurring" && (
                <>
                  <h3 className="titex">
                    Recurrence Pattern{" "}
                  </h3>

                  {/* Frequency Radio Buttons */}
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      value="daily"
                      checked={frequency === "daily"}
                      onChange={handleFrequencyChange}
                      className="form-check-input"
                    />

                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault1d"
                    >
                      Daily
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      value="weekly"
                      checked={frequency === "weekly"}
                      onChange={handleFrequencyChange}
                      className="form-check-input"
                    />

                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault1d"
                    >
                      Weekly
                    </label>
                  </div>

                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      value="monthly"
                      checked={frequency === "monthly"}
                      onChange={handleFrequencyChange}
                      className="form-check-input"
                    />

                    <label
                      className="form-check-label"
                      htmlFor="Monthly"
                    >
                      Monthly
                    </label>
                  </div>

                  {frequency === "daily" && (
                    <div className="d-flex gap-2 mt-2 dailty pt-2 ps-2">
                      <div className="form-check form-check-inline">
                        <input
                          type="radio"
                          value="everyday"
                          checked={dailyOption === "everyday"}
                          className="form-check-input"
                          onChange={(e) =>
                            setDailyOption(e.target.value)
                          }
                        />

                        <label
                          className="form-check-label"
                          htmlFor="Everyday"
                        >
                          Everyday
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          type="radio"
                          value="everyweekday"
                          className="form-check-input"
                          checked={dailyOption === "everyweekday"}
                          onChange={(e) =>
                            setDailyOption(e.target.value)
                          }
                        />

                        <label
                          className="form-check-label"
                          htmlFor="EveryWeekday"
                        >
                          Every Weekday
                        </label>
                      </div>
                    </div>
                  )}

                  {/* Weekly Options */}
                  {frequency === "weekly" && (
                    <div className="mb-3 mt-3 recde">
                      <h4 className="titexfg">Recur on</h4>
                      {[
                        "mon",
                        "tue",
                        "wed",
                        "thu",
                        "fri",
                        "sat",
                        "sun",
                      ].map((day) => (
                        <div className="form-check form-check-inline" key={day}>
                          <input className="form-check-input" type="checkbox"
                            name="weeklyDays"
                            value={day}
                            checked={formData.weeklyDays.includes(
                              day
                            )}
                            // onChange={handleWeeklyDayChange}

                            onChange={handleChange}
                            ref={inputRefs.weeklyDays}
                          // required ={weeklyDays.length === 0} 
                          />
                          <label className="form-check-label" for="frm"> {day.charAt(0).toUpperCase() + day.slice(1)}</label>
                        </div>

                      ))}
                    </div>
                  )}
                  {errors.weeklyDays && (
                    <span style={{ color: "red" }}>
                      {errors.weeklyDays}
                    </span>
                  )}

                  {frequency === "monthly" && (
                    <div className="d-flex gap-3 flex-column mt-3">
                      {/* Day of the Month Option */}
                      <div className="form-check d-flex align-items-center gap-2">
                        <input
                          type="radio"
                          name="nestedMonthly"
                          value="1"
                          checked={nestedMonthly === "1"}
                          onChange={handleNestedMonthlyChange}
                          className="form-check-input"
                        />
                        <label className="form-check-label">
                          Day
                        </label>
                        <input
                          type="number"
                          name="dayOfMonth"
                          className="form-control w-50"
                          value={formData.dayOfMonth}
                          //   onChange={handleDayOfMonthChange}
                          ref={inputRefs.dayOfMonth}
                          onChange={handleChange}
                          disabled={
                            nestedMonthly !== "1" ||
                            frequency !== "monthly"
                          }
                          required
                        />
                        {errors.dayOfMonth && (
                          <span style={{ color: "red" }}>
                            {errors.dayOfMonth}
                          </span>
                        )}
                        of every month
                      </div>

                      {/* The "First, Second, etc." of the Week Option */}
                      <div className="form-check d-flex align-items-center gap-2 flex-wrap">
                        <input
                          type="radio"
                          name="nestedMonthly"
                          value="2"
                          onChange={handleNestedMonthlyChange}
                          className="form-check-input"
                        />
                        <label className="form-check-label">
                          The
                        </label>
                        <select
                          name="firstSecondThird"
                          value={formData.firstSecondThird}
                          onChange={handleChange}
                          ref={inputRefs.firstSecondThird}
                          disabled={nestedMonthly !== "2"}
                          className="form-select w-auto"
                          required
                        >
                          <option value="">Select</option>
                          <option value="first">First</option>
                          <option value="second">Second</option>
                          <option value="third">Third</option>
                          <option value="fourth">Fourth</option>
                          <option value="last">Last</option>
                        </select>
                        {errors.firstSecondThird && (
                          <span style={{ color: "red" }}>
                            {errors.firstSecondThird}
                          </span>
                        )}
                        <select
                          name="dayWeekdayWeekend"
                          value={formData.dayWeekdayWeekend}
                          //   onChange={handleDayWeekdayWeekendChange}
                          onChange={handleChange}
                          ref={inputRefs.dayWeekdayWeekend}
                          disabled={nestedMonthly !== "2"}
                          className="form-select w-auto"
                          required
                        >
                          <option value="">Select</option>
                          <option value="sunday">Sunday</option>
                          <option value="monday">Monday</option>
                          <option value="tuesday">Tuesday</option>
                          <option value="wednesday">Wednesday</option>
                          <option value="thursday">Thursday</option>
                          <option value="friday">Friday</option>
                          <option value="saturday">Saturday</option>
                        </select>
                        {errors.dayWeekdayWeekend && (
                          <span style={{ color: "red" }}>
                            {errors.dayWeekdayWeekend}
                          </span>
                        )}
                        of every
                        <div className="modnd d-flex align-items-center w-100 gap-1">
                          <input
                            type="number"
                            name="monthNo"
                            value={formData.monthNo}
                            onChange={handleChange}
                            ref={inputRefs.monthNo}
                            disabled={nestedMonthly !== "2"}
                            min="1"
                            max="12"
                            className="form-select w-50"
                            required
                          />
                          month(s)<sup className="text-danger">*</sup>
                          {errors.monthNo && (
                            <span style={{ color: "red" }}>
                              {errors.monthNo}
                            </span>
                          )}
                        </div>

                      </div>
                    </div>
                  )}
                  <div className="col-md-12 mt-3 mb-3">
                    <label className="form-label">Range of occurrence</label>
                    <input
                      type="number"
                      value={rangeOfOccurence}
                      onChange={handleRangeOfOccurence}
                      className="form-control"
                    />
                  </div>
                </>
              )}
              <div className="col-md-12">
                <div className="edit_btn d-flex justify-content-end gap-2 btn-footer">
                  <button
                    className="btn-primary"
                    onClick={() => setShowAdd(false)}    //navigate("/profile/detail")
                  >
                    Close
                  </button>
                  {/* <button className="btn-primary active-page">
                                {" "}
                                Add to schedule
                              </button> */}
                  <button type="submit" className="btn-primary active-page">Add to Schedule</button>
                </div>
              </div>


            </form>

            <div className="mt-3 login-msg">
              <div>{successMsg}</div>
            </div>

            <div className="mt-3 error-msg">
              <div>{errorMsg}</div>
            </div>

            {false && ruleString && (
              <div>
                <h3>Payload:</h3>
                <p>{ruleString}</p>
              </div>
            )}

            {false && toText && (
              <div>
                <p>{toText}</p>
              </div>
            )}

            {false && occurrences.length > 0 && (
              <div>
                <h3>Occurrences:</h3>
                <ul>
                  {occurrences.map((date, index) => (
                    <li key={index}>{date.toUTCString()}</li> // Human-readable format
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>}
    </>
  )
}
export default AddScheduleComp;